
const K_DOMAIN = getUrl().domain;
const K_DOWNLOAD = getUrl().load + 'static/code/';
import PKG_JSON from "../../../package.json"

const K_VERSION = PKG_JSON.version
const K_PROJECT_NAME = PKG_JSON.name

/* -------------------------------------------------------------------------------- */
const K_APP_KEY = 'bV9dG9ht2gBNAsaacHpJew==';
const K_QINIU_DO_MAIN = 'https://res.smoktech.com/';
const K_QINIU_VIDEO_IMAGE_END = '?vframe/jpg/offset/0/w';
// https://developer.qiniu.com/dora/1271/image-thin-body-imageslim
// const K_QINIU_IMAGE_SMALL_END_200_SUFFIX = '?imageMogr2/thumbnail/100x100'
const K_QINIU_IMAGE_SMALL_END_200_SUFFIX = '?imageMogr2/thumbnail/200x200'
const K_QINIU_IMAGE_SMALL_END_100_PX_SUFFIX = '?imageMogr2/thumbnail/100x'

function getUrl() {
    let url = {
        domain: '',
        load: ''
    }
    if (window.location.hostname.indexOf('192') > -1 || window.location.hostname.indexOf('localhost') > -1) {
        url = { domain: 'http://192.168.192.157:8100', load: 'http://192.168.192.157:8100' };
    } else {
        url = { domain: 'https://smart.admin.smoktech.com', load: 'https://smart.admin.smoktech.com' };
    }
    return url;
}
export {
    K_DOMAIN, K_DOWNLOAD, K_QINIU_IMAGE_SMALL_END_200_SUFFIX, K_QINIU_IMAGE_SMALL_END_100_PX_SUFFIX, K_VERSION,
    K_PROJECT_NAME,
}
